<div [hidden]="!isLoading" class="ion-text-center">
  <ion-spinner></ion-spinner> <span>{{ message }}</span>
</div>
